import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Se dogaja",
  "description": "",
  "published": "2006-04-24T00:00:00.000Z",
  "redirect_from": ["/blog/se-dogaja/swizec/427"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Na stran je bilo dodanih nekaj stranskih stolpcev (se vedno ne vem kako tocno naj bi se to prevajalo) z oglasi, tagboardom itd. Najvecji dosezek je bil, da je skorajda uspelo napraviti, da se stran pokaze v vseh pomembnejsih browserjih enako. Trenutno se popolnoma pravilno prikaze v FireFoxu in Operi v Interenet Explorerju pa je vse skupaj zelo blizu pravilnosti. Ko pa pride do Konquerorja se stvari zapeletejo... zelo zapeletejo.`}</p>
    <p>{`Pri kompatibilnosti med browserji mi je najbolj zanimivo dejstvo, da ce imas sliko sirine 400px in pod njo div prav tako sirine 400px, ta dva nista enako siroka, razlike je kar 2px, v nobenem brskalniku razen v Operi. Zelo cudno moram reci, se pa da na dokaj preprost nacin zaobiti.`}</p>
    <p>{`V nacrtu je bil se nadomestni strip namesto prvega dela in pa nekaj benerjov, vendar bo kot kaze to nekako moralo pocakati na "jutri"`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      